import { getInstance } from './index';

import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

// Capacitor v3+ : Utiliser isNativePlatform() qui fonctionne correctement
const isNativePlatform = Capacitor.isNativePlatform();

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    console.log('[AuthGuard] Checking auth for route:', to.fullPath);
    console.log('[AuthGuard] isAuthenticated:', authService.isAuthenticated);
    console.log('[AuthGuard] Platform:', Capacitor.getPlatform());
    console.log('[AuthGuard] isNativePlatform:', isNativePlatform);
    
    // If the user is authenticated, continue with the route
    // get user metadata
    if (authService.isAuthenticated) {
      console.log('[AuthGuard] User authenticated, allowing access');
      return next();
    }

    // On native platforms, redirect to login view instead of opening browser directly
    if (isNativePlatform) {
      console.log('[AuthGuard] User not authenticated on native platform, redirecting to /login');
      return next({ path: '/login', query: { redirect: to.fullPath } });
    }
    
    // On web, use standard Auth0 redirect
    console.log('[AuthGuard] User not authenticated on web, starting Auth0 flow');
    authService.loginWithRedirect({ 
      appState: { targetUrl: to.fullPath }
    });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};